export const parseDate = (date) => {
  const d = new Date(date);
  return d.getDate() + "/" + (d.getMonth() + 1) + "/" + d.getFullYear();
};

export const isPreviousToday = (date) => {
  const previousDate = new Date(new Date().getTime() - 86400000);
  return date.getTime() >= previousDate;
};
